import { createFileRoute } from "@tanstack/react-router";
import Profile from "@/components/Profile";

function RouteComponent() {
  return <Profile />;
}

export const Route = createFileRoute("/_authenticated/profile/")({
  component: RouteComponent,
});
